"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reselect = require("reselect");

var _createSelectorsForProperties = _interopRequireDefault(require("./createSelectorsForProperties"));

var _isPropertyDefinedAndNotNull = _interopRequireDefault(require("./isPropertyDefinedAndNotNull"));

var _default = function _default(_ref) {
  var stagedSelector = _ref.stagedSelector,
      properties = _ref.properties;
  var stagedSelectors = (0, _createSelectorsForProperties.default)({
    selector: stagedSelector,
    properties: properties
  });
  var anyChanges = (0, _reselect.createSelector)([stagedSelector], function (staged) {
    return properties.find(function (property) {
      return (0, _isPropertyDefinedAndNotNull.default)({
        selected: staged,
        property: property
      });
    }) !== undefined;
  });

  var getStagedProperty = function getStagedProperty(property) {
    return stagedSelectors[property];
  };

  var getStagedNestedProperty = function getStagedNestedProperty(propertyPath) {
    return stagedSelectors[propertyPath.join("/")];
  };

  var getStagedOrderedMapPropertyAsArray = function getStagedOrderedMapPropertyAsArray(property) {
    return (0, _reselect.createSelector)([getStagedProperty(property)], function (orderedMap) {
      return orderedMap ? orderedMap.valueSeq().toArray() : [];
    });
  };

  return {
    anyChanges: anyChanges,
    getStagedProperty: getStagedProperty,
    getStagedNestedProperty: getStagedNestedProperty,
    getStagedOrderedMapPropertyAsArray: getStagedOrderedMapPropertyAsArray
  };
};

exports.default = _default;
module.exports = exports.default;